module.exports = __webpack_public_path__ + "images/sider-bar-download-app-cn.45be75dd.png";